import { APPLICATION_ID } from '../constants';
import { generateCustomizedTheme } from './baseTheme';

import cfcTheme from './applicationSpecific/cfcTheme';
import laboutiqueebons from './applicationSpecific/laboutiqueebons';
import keetizTheme from './applicationSpecific/keetizTheme';
import ecentimeTheme from './applicationSpecific/ecentimeTheme';
import swagbucksTheme from './applicationSpecific/swagbucksTheme';
import lesnumeriques from './applicationSpecific/lesnumeriques';
import capitalkoalaTheme from './applicationSpecific/capitalkoalaTheme';
import cofidisTheme from './applicationSpecific/cofidisTheme';
import igraalTheme from './applicationSpecific/igraalTheme';
import digitalcopiloteTheme from './applicationSpecific/digitalcopiloteTheme';
import undeuxtroiscomparerTheme from './applicationSpecific/undeuxtroiscomparerTheme';
import bnp4Theme from './applicationSpecific/bnp4Theme';
import bnp6Theme from './applicationSpecific/bnp6Theme';
import bnp8Theme from './applicationSpecific/bnp8Theme';
import bnp10Theme from './applicationSpecific/bnp10Theme';
import bfmTheme from './applicationSpecific/bfmTheme';
import trashbackTheme from './applicationSpecific/trashbackTheme';
import wanteeedTheme from './applicationSpecific/wanteeedTheme';
import jeconomiseTheme from './applicationSpecific/jeconomiseTheme';
import oriwayTheme from './applicationSpecific/oriwayTheme';
import lyziTheme from './applicationSpecific/lyziTheme';
import acmcTheme from './applicationSpecific/acmcTheme';
import macadamTheme from './applicationSpecific/macadamTheme';
import mercinanouTheme from './applicationSpecific/mercinanouTheme';
import ornikarTheme from './applicationSpecific/ornikarTheme';
import powerspaceTheme from './applicationSpecific/powerspaceTheme';
import giftcardgoTheme from './applicationSpecific/giftcardgoTheme';
import generaliTheme from './applicationSpecific/generaliTheme';
import myworldTheme from './applicationSpecific/myworldTheme';
import butterflyTheme from './applicationSpecific/butterflyTheme';

const themeMapping = {
    68: cfcTheme,
    '68-2': laboutiqueebons,
    73: keetizTheme,
    81: ecentimeTheme,
    83: swagbucksTheme,
    105: lesnumeriques,
    107: capitalkoalaTheme,
    111: cofidisTheme,
    117: igraalTheme,
    118: digitalcopiloteTheme,
    119: undeuxtroiscomparerTheme,
    127: bfmTheme,
    131: bnp4Theme,
    132: bnp6Theme,
    133: bnp8Theme,
    134: bnp10Theme,
    139: trashbackTheme,
    140: wanteeedTheme,
    142: jeconomiseTheme,
    146: oriwayTheme,
    147: lyziTheme,
    162: acmcTheme,
    164: wanteeedTheme,
    165: macadamTheme,
    166: mercinanouTheme,
    170: ornikarTheme,
    182: powerspaceTheme,
    189: undeuxtroiscomparerTheme,
    190: giftcardgoTheme,
    191: generaliTheme,
    198: myworldTheme,
    200: butterflyTheme
};

const defaultThemeParams = {
    colors: {},
    fonts: {},
    screenSizes: {},
    overrideFunction: () => {}
};

export const theme = generateCustomizedTheme({
    ...defaultThemeParams,
    ...(themeMapping[APPLICATION_ID] || {})
});



// WEBPACK FOOTER //
// ./src/style/constants.js